<div class="modal fade" id="magicInsightsBulkUnlock" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="magicInsightsBulkUnlockLabel"><i class="fal fa-wand-sparkles"></i> Unlock Magic
          Insights</h5>
        <button type="button" class="close" data-dismiss="modal">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
              @if (showUnlockByIdsMessage) {
                <p>You have selected {{ companyIds.length }} {{ companyIds.length | i18nPlural:pluralMappings.company }}.</p>
              } @else if (showUnlockBySearchMessage) {
                <p>You have selected @if(numberOfCompaniesMatchingSearchParams){ {{numberOfCompaniesMatchingSearchParams}} {{numberOfCompaniesMatchingSearchParams | i18nPlural:pluralMappings.company}} } @else {<zint-loader size="xSmall" [isInline]="true"></zint-loader>} that match your search criteria.</p>
              }

              @if (showSelectionWarning) {
                <p class="status-badge-base status-badge-orange">Please select a maximum of {{ maximumCompaniesToBulkUnlockViaQuery }} companies to unlock.</p>
              }

              @if (!showUnlockByIdsMessage) {
                <label>Number of Companies to Unlock (optional)</label>
                <input type="number" min="1" max="50000" class="form-control mb-4" placeholder="optional" [(ngModel)]="selectedMagicInsightsUnlockCount" (change)="handleCreditCostPreview()">
              }

              <span>Select the Magic Insights Module to unlock for these companies:</span>
              <div class="bg-light mb-2 pt-2 pl-2 max-height-20vh">
                @for (module of modulesInfo; track $index) {
                    <label class="full-width">
                        <input type="radio" [value]="module.id" [(ngModel)]="selectedModuleId" name="selectedModules" (ngModelChange)="handleSelectedModuleIdsChange()"/>
                        {{ module.name }}
                      </label>
                }
              </div>

              @if (totalCreditsCost) {
                <p class="border-bottom pb-2 text-right">
                  This will use <em>up to</em><strong class="ml-1">{{ totalCreditsCost }}</strong> Magic Insights Unlock {{ totalCreditsCost | i18nPlural: pluralMappings.credit }} <sup>*</sup>.
                </p>
              }

              <small class="text-grey-600">
                <sup>*</sup>Credits will only be used for companies where Magic Insights are available and have not yet been unlocked.
              </small>

              @if (canConfirmUnlock) {
                <button class="d-block mx-auto my-3 rounded-btn-base rounded-btn-vivid-outline btn-p-lg"
                        [disabled]="!selectedMagicModuleIds?.length || loadingState.loadingUnlockMagicInsightsModules"
                        (click)="confirmUnlockMIForSelectedCompanies()">
                  <i class="fal fa-check mr-1"></i>Confirm
                </button>
              }
          </div>
        </div>

        <div class="row mt-3">
            @if (loadingQuotas) {
                <div class="col-md-12">
                    <div class="d-flex justify-content-center">
                        <zint-loader size="xSmall"></zint-loader> &nbsp;&nbsp;&nbsp; Pulling Your Quotas...
                    </div>
                </div>
            } @else {
                @if (monthlyQuotaDetails) {
                    <div class="col-md-6">
                        <progress-bar [label]="'Monthly Quota'" [usage]="monthlyQuotaDetails.usage" [quota]="monthlyQuotaDetails.quota"></progress-bar>
                    </div>
                }
                @if (bulkQuotaDetails) {
                    <div class="col-md-6">
                        <progress-bar [label]="'Bulk Quota'" [usage]="bulkQuotaDetails.usage" [quota]="bulkQuotaDetails.quota"></progress-bar>
                    </div>
                }
            }
        </div>

      </div>
    </div>
  </div>
</div>
